import * as types from "../actionTypes";

export const setHiringPlanOtherByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_HIRING_PLAN_OTHER_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setHiringPlanOtherByMonth = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_HIRING_PLAN_OTHER_BY_MONTH,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceHiringPlanOtherYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_HIRING_PLAN_OTHER_YEARS,
      key,
      payload,
    });
  };
};

export const resetHiringPlanOtherReducer = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_HIRING_PLAN_OTHER_REDUCER,
      key,
      payload,
    });
  };
};
